import {
  FETCH_LANGUAGE,
  FETCH_LANGUAGE_SUCCESS,
  FETCH_LANGUAGE_FAILED,
  EDIT_LANGUAGE
} from "../store/types";

export const INITIAL_STATE = {
  langlist: null,
  defaultLanguage: null,     // legacy: keyValuePairs de la langue "default" en DB
  defaultLangLocale: "fr",   // [I18N_FIX] NEW: locale par défaut en DB (ex: fr)
  langMap: {},               // [I18N_FIX] NEW: { fr: keyValuePairs, en: keyValuePairs }
  loading: false,
  error: {
    flag: false,
    msg: null
  }
};

export const languagereducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_LANGUAGE:
      return {
        ...state,
        loading: true,
        error: { flag: false, msg: null }
      };

    case FETCH_LANGUAGE_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
        error: { flag: false, msg: null }
      };

    case FETCH_LANGUAGE_FAILED:
      return {
        ...state,
        langlist: null,
        defaultLanguage: null,
        defaultLangLocale: "fr",
        langMap: {},
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };

    case EDIT_LANGUAGE:
      return state;

    default:
      return state;
  }
};